import React from 'react';
import { useCreateAnnouncement } from '../../../api/announcements-simple';
import { isPendingLike } from '@/shared/pending';

export default function CreateAnnouncementModal({ open, onOpenChange }: { open:boolean; onOpenChange:(open:boolean)=>void }) {
  const create = useCreateAnnouncement();
  const [title, setTitle] = React.useState('');
  const [body, setBody] = React.useState('');
  const [audience, setAudience] = React.useState<'all'|'players'|'parents'|'coaches'>('all');
  const [priority, setPriority] = React.useState<'low'|'normal'|'high'>('normal');
  if (!open) return null;

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await create.mutateAsync({ title, body, audience, priority });
    setTitle('');
    setBody('');
    setAudience('all');
    setPriority('normal');
    onOpenChange(false);
  };

  return (
    <div className="fixed inset-0 z-[70] bg-black/40 flex items-center justify-center" data-testid="announcement-modal-overlay">
      {/* `text-gray-900` forces dark text on the white modal regardless of the
          surrounding dashboard theme. Without this, dark-mode text inheritance
          makes labels/inputs invisible (white-on-white). */}
      <form onSubmit={onSubmit} className="bg-white text-gray-900 rounded-xl p-6 w-full max-w-xl space-y-4" data-testid="announcement-form">
        <h3 className="text-xl font-semibold">Create Announcement</h3>

        <div className="space-y-2">
          <label htmlFor="announcement-title" className="text-sm">Title</label>
          <input 
            id="announcement-title"
            value={title} 
            onChange={e=>setTitle(e.target.value)} 
            className="w-full border rounded-md px-3 py-2" 
            data-testid="announcement-title-input"
            required 
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="announcement-message" className="text-sm">Message</label>
          <textarea 
            id="announcement-message"
            value={body} 
            onChange={e=>setBody(e.target.value)} 
            className="w-full border rounded-md px-3 py-2 h-28" 
            data-testid="announcement-message-input"
            required 
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <label htmlFor="announcement-audience" className="text-sm">Audience</label>
            <select 
              id="announcement-audience"
              value={audience} 
              onChange={e=>setAudience(e.target.value as any)} 
              className="w-full border rounded-md px-3 py-2"
              data-testid="announcement-audience-select"
            >
              <option value="all">All</option><option value="players">Players</option><option value="parents">Parents</option><option value="coaches">Coaches</option>
            </select>
          </div>
          <div className="space-y-2">
            <label htmlFor="announcement-priority" className="text-sm">Priority</label>
            <select 
              id="announcement-priority"
              value={priority} 
              onChange={e=>setPriority(e.target.value as any)} 
              className="w-full border rounded-md px-3 py-2"
              data-testid="announcement-priority-select"
            >
              <option value="low">Low</option><option value="normal">Normal</option><option value="high">High</option>
            </select>
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-2">
          <button 
            type="button" 
            onClick={() => onOpenChange(false)} 
            className="px-4 py-2 rounded-md border"
            data-testid="announcement-cancel-button"
          >
            Cancel
          </button>
          <button 
            type="submit"
            disabled={isPendingLike(create)} 
            className="px-4 py-2 rounded-md bg-blue-600 text-white"
            data-testid="announcement-submit-button"
          >
            {isPendingLike(create) ? 'Creating…' : 'Create'}
          </button>
        </div>
      </form>
    </div>
  );
}